import React, { useState, useRef, useEffect } from "react";
import ResizeObserver from "resize-observer-polyfill";

export const useResize = (
  refElement: React.RefObject<Element>,
  additionalSubscribeDependency: any = null
) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const resizeObserver = useRef(
    new ResizeObserver((entries: ResizeObserverEntry[]) => {
      // We wrap it in requestAnimationFrame to avoid this error - ResizeObserver loop limit exceeded
      window.requestAnimationFrame(() => {
        for (let entry of entries) {
          if (entry.contentBoxSize) {
            // Firefox implements `contentBoxSize` as a single content rect, rather than an array
            const contentBoxSize = Array.isArray(entry.contentBoxSize)
              ? entry.contentBoxSize[0]
              : entry.contentBoxSize;

            setWidth(contentBoxSize.inlineSize);
            setHeight(contentBoxSize.blockSize);
          } else {
            setWidth(entry.contentRect.width);
            setHeight(entry.contentRect.height);
          }
        }
      });
    })
  );

  useEffect(() => {
    const resizeObserverRef = resizeObserver?.current;
    const currentRef = refElement?.current;

    if (!currentRef || !resizeObserverRef) {
      return;
    }

    resizeObserverRef.observe(currentRef);

    return () => {
      resizeObserverRef.unobserve(currentRef);
    };
  }, [refElement, resizeObserver, additionalSubscribeDependency]);

  return [width, height];
};
